export type CrispBootstrap = {
  website_id: string;
  token?: string;
  // The exact value the backend signed; push it instead of the raw email.
  email?: string;
  email_signature?: string;
};

// The token of the user the chat is bound to. Kept across page loads so that
// it is set before l.js loads and no session:reset is needed on every load.
const TOKEN_LS_KEY = "crispTokenId";

const readStoredToken = (): string | null => {
  try {
    return localStorage.getItem(TOKEN_LS_KEY);
  } catch (e) {
    return null;
  }
};

const storeToken = (token: string | undefined) => {
  try {
    if (token) {
      localStorage.setItem(TOKEN_LS_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_LS_KEY);
    }
  } catch (e) {}
};

const setTokenId = (token: string | undefined) => {
  (window as any).CRISP_TOKEN_ID = token;
  storeToken(token);
};

// Call before injecting l.js.
export const restoreCrispToken = () => {
  const token = readStoredToken();
  if (token) {
    (window as any).CRISP_TOKEN_ID = token;
  }
};

export const configureCrispForUser = (
  email: string,
  firstName: string,
  bootstrap?: CrispBootstrap
) => {
  if (!bootstrap || !bootstrap.website_id || !window.$crisp) {
    return;
  }

  const isVerified = !!(bootstrap.token && bootstrap.email_signature);
  const token = isVerified ? bootstrap.token : undefined;

  // Reset only when the chat is bound to another user (login, user switch).
  // Crisp applies a token set after l.js is loaded on the following reset.
  if ((window as any).CRISP_TOKEN_ID !== token) {
    setTokenId(token);
    window.$crisp.push(["do", "session:reset"]);
  }

  if (isVerified) {
    window.$crisp.push([
      "set",
      "user:email",
      [bootstrap.email || email, bootstrap.email_signature],
    ]);
  } else {
    window.$crisp.push(["set", "user:email", [email]]);
  }

  window.$crisp.push(["set", "user:nickname", [firstName]]);
};

export const resetCrispSession = () => {
  setTokenId(undefined);
  if (!window.$crisp) {
    return;
  }

  window.$crisp.push(["do", "session:reset"]);
};
